<div class="app-shell flex-row h-100 w-100">
  <app-sidebar class="desktop-sidebar"></app-sidebar>
  <div class="app-workspace flex-col min-w-0">
    <header class="utility-bar mobile-utility-bar flex-row start-center gap-16">
      <app-user-menu class="mobile-user-menu"></app-user-menu>
      @if (organization(); as current) {
        <mat-select
          class="mobile-organization-select"
          panelClass="mobile-organization-panel"
          [attr.aria-label]="'CHAT_AUTH.ORGANIZATION' | translate"
          [value]="current._id"
          [disabled]="switchInProgress() || availableOrganizations().length < 2"
          (selectionChange)="switchOrganization($event)"
        >
          <mat-select-trigger class="mobile-organization-trigger">
            <ui-avatar
              class="mobile-organization-avatar"
              [name]="current.settings.orgName"
              [color]="current.settings.orgColor"
              aria-hidden="true"
            ></ui-avatar>
            <span class="mobile-organization-name">{{
              current.settings.orgName
            }}</span>
            <span class="mobile-organization-chevron" aria-hidden="true"></span>
          </mat-select-trigger>
          @for (
            organization of availableOrganizations();
            track organization.id
          ) {
            <mat-option [value]="organization.id">
              <span class="mobile-organization-option">
                <ui-avatar
                  class="mobile-organization-avatar"
                  [name]="organization.name"
                  [color]="organization.color"
                  aria-hidden="true"
                ></ui-avatar>
                <span class="mobile-organization-name">{{
                  organization.name
                }}</span>
              </span>
            </mat-option>
          }
        </mat-select>
      }
    </header>
    <main class="flex min-h-0"><router-outlet /></main>
  </div>
</div>
<app-chat-media-batches />
